// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import todo from '@src/views/apps/todo/store'
import chat from '@src/views/apps/chat/store'
import users from '@src/views/apps/user/store'
import ghate from '@src/views/apps/ghate/store'
import marsoulat from '@src/views/apps/marsoulat/store'
import email from '@src/views/apps/email/store'
import kanban from '@src/views/apps/kanban/store'
import invoice from '@src/views/apps/invoice/store'
import news from '@src/views/apps/news/store'
import login from '@src/views/pages/authentication/store'
import calendar from '@src/views/apps/calendar/store'
import ecommerce from '@src/views/apps/ecommerce/store'
import dataTables from '@src/views/tables/data-tables/store'
import permissions from '@src/views/apps/roles-permissions/store'
import products from '@src/views/apps/products/store'
import payments from '@src/views/apps/payment/store'
import tariffs from '@src/views/apps/prices/store'
import dashboard from '@src/views/dashboard/ecommerce/store'

const rootReducer = {
  auth,
  todo,
  chat,
  email,
  users,
  kanban,
  navbar,
  layout,
  invoice,
  calendar,
  ecommerce,
  dataTables,
  permissions,
  login,
  news,
  products,
  tariffs,
  dashboard,
  payments,
  ghate,
  marsoulat
}

export default rootReducer
